import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { RequestStatus } from '../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  buttonLabelI18nKey: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  changeFileVisibilityRequestStatus: PropTypes.oneOf(Object.keys(RequestStatus)).isRequired
};
export default class FileVisibilityConfirmButton extends Component {
  render() {
    const {
      changeFileVisibilityRequestStatus,
      onClick,
      buttonLabelI18nKey
    } = this.props;
    return /*#__PURE__*/_jsx(UILoadingButton, {
      use: "danger",
      onClick: onClick,
      failed: changeFileVisibilityRequestStatus === RequestStatus.FAILED,
      loading: changeFileVisibilityRequestStatus === RequestStatus.PENDING,
      keepResultAfterFinish: true,
      autoFocus: false,
      preventClicksOnLoading: true,
      "data-test-id": "file-visibility-confirm-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonLabelI18nKey
      })
    });
  }
}
FileVisibilityConfirmButton.propTypes = propTypes;